import { mergeToken } from 'antd/es/theme/internal';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var antPrefixCls = '.ant-input';
var genActiveStyle = function genActiveStyle(token) {
  return {
    // 替换新token
    borderColor: "" + token.activeBorderColor,
    boxShadow: 'none'
  };
};
var genStatusStyle = function genStatusStyle(token, parentCls) {
  var _ref, _ref2;
  var colorError = token.colorError,
    colorErrorOutline = token.colorErrorOutline;
    token.colorErrorBorderHover;
  return _ref2 = {}, _ref2["&-status-error:not(" + parentCls + "-disabled):not(" + parentCls + "-borderless)" + parentCls] = (_ref = {
    '&:focus, &-focused': _extends({}, genActiveStyle(mergeToken(token, {
      // 替换新token
      activeBorderColor: colorError,
      controlOutline: colorErrorOutline
    })))
  }, _ref[antPrefixCls + "-prefix, " + antPrefixCls + "-suffix"] = {
    color: colorError
  }, _ref), _ref2;
};
var genInputSizeStyle = function genInputSizeStyle(token) {
  return {
    '&': {
      padding: '5px 12px'
    },
    '&-sm': {
      padding: '3px 12px'
    }
  };
};
var genInputStyle = function genInputStyle(token) {
  var _typeColor, _extends2, _ref3;
  var controlHeightSM = token.controlHeightSM,
    lineWidth = token.lineWidth;
  var FIXED_CHROME_COLOR_HEIGHT = 16;
  var colorSmallPadding = (controlHeightSM - lineWidth * 2 - FIXED_CHROME_COLOR_HEIGHT) / 2;
  return _ref3 = {}, _ref3[antPrefixCls] = _extends({
    '&::placeholder': {
      color: token.colorPlaceholder
    }
  }, genInputSizeStyle(), (_extends2 = {
    // ...genStatusStyle(token, antPrefixCls),

    '&[type="color"]': (_typeColor = {
      height: token.controlHeight
    }, _typeColor["&" + antPrefixCls + "-sm"] = {
      height: controlHeightSM,
      paddingTop: colorSmallPadding,
      paddingBottom: colorSmallPadding
    }, _typeColor)
  }, _extends2["&-outlined&-disabled,&-outlined[disabled]"] = {
    borderColor: token.colorBorderSecondary,
    color: token.colorTextQuaternary
  }, _extends2)), _ref3;
};
var genAffixStyle = function genAffixStyle(token) {
  var _extends3, _ref4;
  return _ref4 = {}, _ref4[antPrefixCls + "-affix-wrapper"] = _extends({}, genInputSizeStyle(), (_extends3 = {
    display: 'inline-flex'
  }, _extends3["&:not(" + antPrefixCls + "-status-error)"] = {
    '&-focused, &:focus': {
      zIndex: 1
    }
  }, _extends3['.ant-input-clear-icon'] = {
    padding: 0
  }, _extends3)), _ref4;
};
var genGroupStyle = function genGroupStyle(token) {
  var _antInputGroup, _ref5;
  var antCls = token.antCls;
  return _ref5 = {}, _ref5['.ant-input-group'] = (_antInputGroup = {}, _antInputGroup["&-sm " + antPrefixCls + ", &-sm > " + antPrefixCls + "-group-addon"] = {
    padding: "3px 12px"
  }, _antInputGroup["&-sm " + antCls + "-select-single " + antCls + "-select-selector"] = {
    height: token.controlHeightSM
  }, _antInputGroup['.ant-input-group-addon'] = {
    padding: '0 8px',
    color: token.colorText,
    // border: `${token.lineWidth}px ${token.lineType} ${token.colorBorder}`,
    backgroundColor: token.colorFillSecondary
  }, _antInputGroup), _ref5;
};
var genSearchInputStyle = function genSearchInputStyle(token) {
  var _searchPrefixCls, _ref6;
  var searchPrefixCls = ".ant-input-search";
  return _ref6 = {}, _ref6[searchPrefixCls] = (_searchPrefixCls = {}, _searchPrefixCls[antPrefixCls + ":hover"] = {
    borderColor: "" + token.hoverBorderColor
  }, _searchPrefixCls[antPrefixCls + ":focus"] = {
    borderColor: "" + token.activeBorderColor
  }, _searchPrefixCls[antPrefixCls + "-affix-wrapper"] = _extends({}, genInputSizeStyle()), _searchPrefixCls[searchPrefixCls + "-button"] = {
    height: token.controlHeight,
    borderColor: token.colorBorder,
    // borderLeft: 'none',
    // '&:hover, &:focus': {
    //   zIndex: 1,
    // },
    '&:not(.ant-btn-primary):active': {
      color: token.colorText + " !important"
    }
  }, _searchPrefixCls["&-small " + searchPrefixCls + "-button"] = {
    height: token.controlHeightSM
  }, _searchPrefixCls), _ref6;
};
var genTextAreaStyle = function genTextAreaStyle(token) {
  var _textAreaPrefixCls, _ref7;
  var textAreaPrefixCls = antPrefixCls + "-textarea-affix-wrapper";
  return _ref7 = {}, _ref7[textAreaPrefixCls] = (_textAreaPrefixCls = {}, _textAreaPrefixCls[antPrefixCls] = {
    padding: '8px 12px'
  }, _textAreaPrefixCls), _ref7[antPrefixCls + "-textarea-show-count .ant-input-data-count"] = {
    color: token.colorTextDisabled,
    bottom: '-24px',
    fontSize: '12px'
  }, _ref7;
};
function initInputToken(token) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return mergeToken(token, {
    inputAffixPadding: token.paddingXXS,
    inputPaddingVertical: Math.max(Math.round((token.controlHeight - token.fontSize * token.lineHeight) / 2 * 10) / 10 - token.lineWidth, 3),
    inputPaddingVerticalLG: Math.ceil((token.controlHeightLG - token.fontSizeLG * token.lineHeightLG) / 2 * 10) / 10 - token.lineWidth,
    inputPaddingVerticalSM: Math.max(Math.round((token.controlHeightSM - token.fontSize * token.lineHeight) / 2 * 10) / 10 - token.lineWidth, 0),
    inputPaddingHorizontal: token.paddingSM - token.lineWidth,
    inputPaddingHorizontalSM: token.paddingXS - token.lineWidth,
    inputPaddingHorizontalLG: token.controlPaddingHorizontal - token.lineWidth,
    inputBorderHoverColor: token.colorPrimaryHover,
    inputBorderActiveColor: token.colorPrimaryHover
  });
}
var inputStyleFn = function inputStyleFn(preToken) {
  var inputToken = initInputToken(preToken);
  return [genInputStyle(inputToken), genTextAreaStyle(inputToken), genAffixStyle(), genGroupStyle(inputToken), genSearchInputStyle(inputToken)];
};

export { genActiveStyle, genInputSizeStyle, genStatusStyle, initInputToken, inputStyleFn };
